import React from "react";
import "./../Workspace2/sidebar.css";
import logov2 from "../../assets/signin.png";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useHistory } from "react-router";
import { getWorkspace } from "../Components/ApiServices/apiHandler";
import { useState } from "react";
import { useEffect } from "react";
// import CheckIcon from "@mui/icons-material/Check";

import commoncss from "../../myfin_v2/css/common.module.css"
import wsCreationcss from '../../myfin_v2/css/workspaceCreation.module.css'
import pgbarcss from '../../myfin_v2/css/wsCreationProgressBar.module.css'

import { ReactComponent as CheckIcon } from '../../myfin_v2/assets/icons/whiteCheck.svg'

const WSProgressBar = (props) => {
  let history = useHistory();
  const [workspace, setWorkspace] = useState("");

  useEffect(() => {
    if (typeof props?.id !== 'undefined' && props?.id !== null) {
      getWorkspaceDetails();
    }

  }, []);

  const stepChange = (field) => {
    if (typeof props?.id == 'undefined' && props?.id == null) {
      console.log("not work")
      return false;
    }
    if (field === "getting_started") {
      history.push(`/workspacelayout`);
    } else if (field === "workspace_setup") {
      history.push(`/workspacesetup/${props?.id}`);
    } else if (field === "add_companies") {
      history.push(`/addCompanies/${props?.id}`);
    } else if (field === "import_register") {
      history.push(`/importregister/${props?.id}`);
    } else if (field === "import_presets") {
      history.push(`/importPreset/${props?.id}`);
    }
    else if (field === "invite_team") {
      history.push(`/inviteteammember/${props?.id}`);
    }
  };

  const getWorkspaceDetails = async () => {
    const res = await getWorkspace(props?.id);
    console.log(res);
    if (res.status === 200) {
      setWorkspace(res?.data?.getworkspace[0]);
    }
  };
  const DashbordPage = () => {
    history.push(`/dashboard`)
  }

  var ActiveStage = props.activePage;

  let outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 1? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.inactiveBadgeBgClr}`;
  let content1 = 1;

  let outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 2? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.inactiveBadgeBgClr}`;
  let content2 = 2;

  let outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge3 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 3? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.inactiveBadgeBgClr}`;
  let content3 = 3;

  let outerBadge4 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge4 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 4? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.inactiveBadgeBgClr}`;
  let content4 = 4;

  let outerBadge5 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge5 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 5? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter5 = `${pgbarcss.numbConnterStart5} ${pgbarcss.inactiveBadgeBgClr}`;
  let content5 = 5;

  let outerBadge6 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  let innerBadge6 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr} ${ActiveStage === 6? pgbarcss.numBadgeInnerActive:''}`;
  let badgeConnecter6 = `${pgbarcss.numbConnterStart7} ${pgbarcss.inactiveBadgeBgClr}`;
  let content6 = 6;

  // let outerBadge7 = `${pgbarcss.numBadge} ${pgbarcss.inactiveBadgeBgClr} ${pgbarcss.badge}`;
  // let innerBadge7 = `${pgbarcss.numBadgeInner} ${pgbarcss.innerBadgeBgClr}`;
  // let badgeConnecter7 = `${pgbarcss.numbConnterStart7} ${pgbarcss.inactiveBadgeBgClr}`;
  // let content7 = 7;

  if (ActiveStage === 1) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.activeBadgeBgClr}`;

    // badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 2) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.completedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.middleActiveBar}`;

    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 3) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.completedBadgConnecterClr}`;
    content2 = <CheckIcon />;

    outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.middleActiveBar}`;

    badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 4) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content2 = <CheckIcon />;

    outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge3 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.completedBadgConnecterClr}`;
    content3 = <CheckIcon />;

    outerBadge4 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.middleActiveBar}`;

    badgeConnecter5 = `${pgbarcss.numbConnterStart5} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 5) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content2 = <CheckIcon />;

    outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge3 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content3 = <CheckIcon />;

    outerBadge4 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge4 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.completedBadgConnecterClr}`;
    content4 = <CheckIcon />;

    outerBadge5 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter5 = `${pgbarcss.numbConnterStart5} ${pgbarcss.middleActiveBar}`;

    badgeConnecter6 = `${pgbarcss.numbConnterStart6} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 6) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content2 = <CheckIcon />;

    outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge3 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content3 = <CheckIcon />;

    outerBadge4 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge4 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content4 = <CheckIcon />;

    outerBadge5 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge5 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter5 = `${pgbarcss.numbConnterStart5} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content5 = <CheckIcon />;

    outerBadge6 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    badgeConnecter6 = `${pgbarcss.numbConnterStart7} ${pgbarcss.lastConnecter}`;

    // badgeConnecter7 = `${pgbarcss.numbConnterStart6} ${pgbarcss.lastInActiverBar}`;
  }

  else if (ActiveStage === 7) {
    outerBadge1 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge1 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter1 = `${pgbarcss.numbConnterStart1} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content1 = <CheckIcon />;

    outerBadge2 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge2 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter2 = `${pgbarcss.numbConnterStart2} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content2 = <CheckIcon />;

    outerBadge3 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge3 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter3 = `${pgbarcss.numbConnterStart3} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content3 = <CheckIcon />;

    outerBadge4 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge4 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter4 = `${pgbarcss.numbConnterStart4} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content4 = <CheckIcon />;

    outerBadge5 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge5 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter5 = `${pgbarcss.numbConnterStart5} ${pgbarcss.fullCompletedBadgConnecterClr}`;
    content5 = <CheckIcon />;

    outerBadge6 = `${pgbarcss.numBadge} ${pgbarcss.completeBadgeClr} ${pgbarcss.badge}`;
    innerBadge6 = `${pgbarcss.numBadgeInner} ${pgbarcss.completeBadgeClr}`;
    badgeConnecter6 = `${pgbarcss.numbConnterStart6} ${pgbarcss.completedBadgConnecterClr}`;
    content6 = <CheckIcon />;

    // outerBadge7 = `${pgbarcss.numBadge} ${pgbarcss.activeBadegClr} ${pgbarcss.badge}`;
    // badgeConnecter7 = `${pgbarcss.numbConnterStart7} ${pgbarcss.middleActiveBar}`;
  }


  return (
    <>

    <div className={pgbarcss.numBadgeMainContainer}>
            <div className={pgbarcss.numberContainer}>
                <div onClick={() => {}} key={1} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerOne}`} style={{"width": "calc(8%)"}}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${pgbarcss.badge}`}>
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText1}`}>Getting Started</div>
                </div>
                <div onClick={() => {}} key={2} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${pgbarcss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText2}`}>Workspace Setup</div>
                </div>
                <div onClick={() => {}} key={3} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${pgbarcss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText3}`}>Add Companies</div>
                </div>
                <div onClick={() => {}} key={4} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerFour}`}>
                    <div className={badgeConnecter4}></div>
                    <div className={`${outerBadge4} ${pgbarcss.badge}`}>
                        <div className={innerBadge4}>{content4}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText4}`}>Import Registers</div>
                </div>
                <div onClick={() => {}} key={5} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerFive}`}>
                    <div className={badgeConnecter5}></div>
                    <div className={`${outerBadge5} ${pgbarcss.badge}`}>
                        <div className={innerBadge5}>{content5}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText5}`}>Import Presets</div>
                </div>
                <div onClick={() => {}} key={6} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerSeven}`} style={{"width": "calc(8%)"}}>
                    <div className={badgeConnecter6}></div>
                    <div className={`${outerBadge6} ${pgbarcss.badge}`}>
                        <div className={innerBadge6}>{content6}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText6}`}>Invite Team Members</div>
                </div>
                {/* <div onClick={() => {}} key={7} className={`${pgbarcss.numBadgeContainer} ${pgbarcss.badgeContainerSeven}`}>
                    <div className={badgeConnecter7}></div>
                    <div className={`${outerBadge7} ${pgbarcss.badge}`}>
                        <div className={innerBadge7}>{content7}</div>
                    </div>
                    <div className={`${pgbarcss.numberText} ${pgbarcss.numberText7}`}>pass ecl entries</div>
                </div> */}
            </div>
        </div>
    </>
  );
};

export default WSProgressBar;
